import React, { useMemo } from "react";
import { Card, Row, Col, OverlayTrigger, Tooltip, Placeholder } from "react-bootstrap";
import { formatThousand } from "@revbox/helpers-fe";
import { auctionCreditBalanceCardLabels } from "@revbox/localization";
import { useCookiesContext } from "../../../contexts/CookiesContext";
import { OverlayContainer } from "../../../services/currency/RenderTooltip";
import { useEurUsdRate } from "../../../hooks/useEurUsdRate";

const POST_PAYMENT_BILLING_TYPES = [2, 3, 6];

export default function NNXAuctionCreditBalanceCard({ campaign, id }) {
  const { getLanguageAbbr } = useCookiesContext();
  const languageAbbr = getLanguageAbbr();
  const multilang = auctionCreditBalanceCardLabels[languageAbbr];
  const { rate } = useEurUsdRate();

  if (!campaign) {
    return (
      <Placeholder as={Card.Title} animation="glow" style={{ color: "var(--bs-body-color)" }}>
        <Placeholder style={{ height: 145, width: "100%" }} />
      </Placeholder>
    );
  }

  const isPostPayment = POST_PAYMENT_BILLING_TYPES.includes(campaign?.ppc_billing_type);

  const value = isPostPayment
      ? Number(campaign?.ppc_balance || 0)
      : Number((campaign?.ppc_paid_credits || 0) + (campaign?.ppc_free_credits || 0));

  const amount = Number(value.toFixed(2))
  const title = isPostPayment ? multilang.postPayment : multilang.title

  const showTooltip = campaign?.ppc_active || campaign?.ppc_paused;

  const content = (
    <Card className="card-one" id={id}>
      <Card.Body id={id}>
        <Row>
          <Col xs="12">
            <h3 className="card-value mb-0 flex justify-content-between">
              <OverlayContainer amount={amount} rate={rate}>
                <b>${formatThousand(amount)}</b>
              </OverlayContainer>
            </h3>
            <label className="card-title fw-medium text-dark mb-1">{title}</label>
          </Col>
        </Row>
      </Card.Body>

      <Card.Footer
        style={{
          height: "60px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Row>
          <Col xs="12" />
        </Row>
      </Card.Footer>
    </Card>
  );

  return showTooltip ? (
    <OverlayTrigger placement="bottom" overlay={<Tooltip placement="bottom">{multilang.tooltip}</Tooltip>}>
      {content}
    </OverlayTrigger>
  ) : (
    content
  );
}
